"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { Select } from "@filadd/phi-plus-core";
import { css } from "@filadd/phi-plus-styled-system/css";
import { ReleaseOption } from "./ReleaseOption";
const STUDY_TRAIL_USER_APPLICATION = "study-trail-user";
// Helper functions from the reference code
const studyTrailPath = (courseSlug) => `/courses/${courseSlug}/home`;
const contentPath = (courseSlug) => `/courses/${courseSlug}/content`;
export const ReleaseSelector = ({ releases, courseTitle, layoutFeatures, locale, t, }) => {
    // Don't render if no releases are available
    if (releases.length === 0) {
        return null;
    }
    // Check if any layoutFeature is owned by study-trail-user application
    const hasStudyTrailFeature = layoutFeatures === null || layoutFeatures === void 0 ? void 0 : layoutFeatures.some((feature) => feature.owned_by_application === STUDY_TRAIL_USER_APPLICATION);
    // Convert releases to course navigation data
    const coursesNavigationData = releases.map((release) => {
        var _a;
        return ({
            courseTitle: release.course.title,
            location: hasStudyTrailFeature
                ? studyTrailPath(release.course.slug)
                : contentPath(release.course.slug),
            expiresAt: (_a = release.expires_at) !== null && _a !== void 0 ? _a : undefined,
        });
    });
    return (_jsx(Select, { groups: [
            {
                items: coursesNavigationData.map(({ courseTitle: title, expiresAt, location }) => ({
                    label: title,
                    value: title,
                    children: (_jsx(ReleaseOption, { label: title, courseExpires: expiresAt, location: location, locale: locale, t: t })),
                })),
            },
        ], value: [courseTitle], itemIndicator: _jsx("span", {}), className: css({
            "& .select__trigger": {
                backgroundColor: "transparent",
                color: "white",
                border: "1px solid white",
            },
            "& .select__trigger > svg": {
                color: "white",
            },
            "& .select__valueText": {
                color: "white",
                textWrap: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
            },
            "& .select__itemGroupLabel": {
                color: "primary",
            },
            "& .select__itemGroup": {
                maxWidth: "calc(100vw - 40px)",
            },
            "& .select__item": {
                py: 2,
                height: "auto",
            },
        }) }));
};
//# sourceMappingURL=ReleaseSelector.js.map